import React, { useEffect, useState } from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import TextArea from './components/TextArea';
import Table from './components/Table';
import HorizontalView from './components/HorizontalView';
import isEmptyObject from './utils/ObjectUtils.js';
import './App.css';

const App = () => {
  const [inputJSON, setInputJSON] = useState('');
  const [jsonData, setJsonData] = useState(null);
  const [tableFlag, setTableFlag] = useState(true);
  const [showDataType, setShowDataType] = useState(true);
  const [showInfoSection, setShowInfoSection] = useState(true);
  const hasRenderableTable =
    jsonData && !isEmptyObject(jsonData) && JSON?.stringify(jsonData);
  const isInfoVisible = !hasRenderableTable || showInfoSection;

  useEffect(() => {
    if (hasRenderableTable) {
      setShowInfoSection(false);
    }
  }, [hasRenderableTable]);

  return (
    <ErrorBoundary>
      <div>
        <TextArea
          inputJSON={inputJSON}
          setInputJSON={setInputJSON}
          jsonData={jsonData}
          setJsonData={setJsonData}
          setTableFlag={setTableFlag}
          tableFlag={tableFlag}
          showDataType={showDataType}
          setShowDataType={setShowDataType}
        />
        {jsonData && isEmptyObject(jsonData) ? (
          <p className='nothing-to-display'> Nothing to Display </p>
        ) : hasRenderableTable ? (
          tableFlag === true ? (
            <div className='horizontal-container'>
              <HorizontalView
                jsonData={jsonData}
                showDataType={showDataType}
              />
            </div>
          ) : (
            <div className='vertical-container'>
              <Table
                jsonData={jsonData}
                showDataType={showDataType}
              />
            </div>
          )
        ) : null}

        <main className='site-content'>
          {hasRenderableTable ? (
            <button
              className='info-toggle-button'
              onClick={() => setShowInfoSection((prevState) => !prevState)}
            >
              {isInfoVisible ? 'Hide info' : 'View info'}
            </button>
          ) : null}
          {isInfoVisible ? (
            <section
              className={`content-section ${
                hasRenderableTable ? 'content-section--with-top-border' : ''
              }`}
            >
              <h1>TabularJSON: Convert JSON and JSONL to Table Views</h1>
              <p>
                TabularJSON is a free browser-based utility for developers and
                analysts who need to inspect structured data quickly. Paste JSON
                or JSONL data, validate it, and switch between horizontal and
                vertical table views for easier scanning.
              </p>
              <h2>How to Use</h2>
              <ul>
                <li>Paste JSON or JSONL in the editor</li>
                <li>Validate and reformat data</li>
                <li>Transpose between table layouts</li>
                <li>Copy processed output</li>
              </ul>
            </section>
          ) : null}

          <footer className='site-footer'>
            <a href='/privacy-policy.html'>Privacy Policy</a>
            <a href='/terms.html'>Terms</a>
            <a href='/about.html'>About</a>
            <a href='/contact.html'>Contact</a>
          </footer>
        </main>
      </div>
    </ErrorBoundary>
  );
};

export default App;
